module.exports = __webpack_public_path__ + "img/jjin_final_3.fc7e27fd.jpg";